import React from "react";

const Pagination = ({ productsPP, totalProducts, paginate}) => {
const pageNumbers = [];

for (let i = 1; i <= Math.ceil(totalProducts / productsPP); i++) {
pageNumbers.push(i);
}

return (
<nav>
  <ul className="pagination">
    {pageNumbers.map(number => (
      <li key={number} className="page-item">
        <a onClick={(e) => {paginate(number); e.preventDefault();}} href="!#" className="page-link">
           {number}
       </a>
     </li>
     ))};
  </ul>
</nav>
);
}
export default Pagination;
